import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLatitude = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.99967 1.33301C4.33301 1.33301 1.33301 4.33301 1.33301 7.99967C1.33301 11.6663 4.33301 14.6663 7.99967 14.6663C11.6663 14.6663 14.6663 11.6663 14.6663 7.99967C14.6663 4.33301 11.6663 1.33301 7.99967 1.33301ZM7.99967 2.66634C9.99967 2.66634 11.6663 3.73301 12.5997 5.33301H3.39967C4.33301 3.73301 5.99967 2.66634 7.99967 2.66634ZM7.99967 13.333C5.99967 13.333 4.33301 12.2663 3.39967 10.6663H12.5997C11.6663 12.2663 9.99967 13.333 7.99967 13.333ZM2.86634 9.33301C2.73301 8.93301 2.66634 8.46634 2.66634 7.99967C2.66634 7.53301 2.73301 7.06634 2.86634 6.66634H13.1997C13.333 7.06634 13.3997 7.53301 13.3997 7.99967C13.3997 8.46634 13.333 8.93301 13.1997 9.33301H2.86634Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgLatitude);
export default ForwardRef;
